
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      title: "How To Pack A Bike | Bike Packing Instructions | Bikeflights.com",
      items: [
        {
          image: "BikeFlights_v4-prep",
          title: "Prepare For Packing",
          content: [
            "Gather your tools, packing materials, bike and bike box or case. You will need the following to get started:",
            "Allen Wrenches",
            "Torx Wrenches",
            "Foam Tubing",
            "Packing Tape",
            "Zip Ties",
            "Axle Spacers",
            "Disc Brake Spacers",
            "Accessory Bag (for removed small parts)",
            "Wheel Bags",
          ],
        },

        {
          image: "bf-pack-instructions-remove-pedals-v5",
          title: "Remove Your Pedals",
          content: [
            "Remove both of your pedals, and place them in your accessory bag.",
            "Your right pedal has a regular thread (counter-clockwise to loosen), while your left pedal is reverse threaded (clockwise to loosen).",
          ],
        },

        {
          image: "BikeFlights_v3_2",
          title: "Remove Your Wheels",
          content: [
            "Remove your wheels from your bike.",
            "If your bike has disc brakes, place a brake pad spacer in your brake calipers to maintain disc brake separation. Secure in place with a zip tie.",
          ],
        },

        {
          image: "BikeFlights_v4-rotors",
          title: "Remove Your Disc Rotors",
          content: [
            "If your bike has disc brakes, remove the rotors from each wheel, and place them in your accessory bag.",
            "Secure your disc brake bolts back in the hub.",
          ],
        },

        {
          image: "BikeFlights_v4-bottle-cage",
          title: "Remove Your Bottle Cages",
          content: [
            "Remove your bottles cages, and place them in your accessory bag.",
            "Screw the bottle cage bolts back into the frame.",
            "If your bike has fenders, frame bags, mini pumps, GPS units or other attachments, remove those as well.",
          ],
        },

        {
          image: "BikeFlights_v4-remove-handlebar",
          title: "Remove Your Bars",
          content: [
            "Mark your handlebar position.",
            "Remove your handlebars from your stem.",
            "Leave your stem in place to maintain bearing compression in your head tube.",
            "Screw the stem bolts back into your stem.",
          ],
        },

        {
          image: "BikeFlights_v4-remove-seatpost",
          title: "Remove Your Seatpost ",
          content: [
            "Mark your saddle height with tape or a marker",
            "Remove your seatpost, and tighten your seatpost collar.",
          ],
        },

        {
          image: "BikeFlights_v4-der",
          title: "Remove Your Derailleur ",
          content: ["Remove your rear derailleur."],
        },

        {
          image: "bf-pack-instructions-protect-frame",
          title: "Protect Your Frame and Fork with Foam Tubing",
          content: [
            "Wrap your entire frame and fork with dense foam tubing.",
            "Secure the foam tubing with zip ties.",
          ],
        },

        {
          image: "bf-pack-instructions-protect-bars-v5",
          title: " Protect Your Handlebars with Foam Tubing",
          content: [
            "Wrap your fork and your bars with dense foam tubing.",
            "Pad around your shift levers and brake levers",
            "Secure foam tubing with zip ties.",
          ],
        },

        {
          image: "BikeFlights_v4-thru-axel",
          title: " Protect Frame and Fork with Spacers",
          content: [
            "Place and secure spacers between your rear dropouts and your fork dropouts",
            "Use pre-cut PVC spacers, plastic spacers (like those used by manufacturers) secured with tape, or old hubs secured with skewers or thru axles.",
          ],
        },

        {
          image: "bf-pack-instructions-secure-derailleur-v5",
          title: " Secure Your Derailleur ",
          content: [
            "Wrap your removed derailleur with foam, and zip-tie it to the inside of your rear triangle.",
            "Secure you extra chain slack with a zip tie to the chain stay.",
          ],
        },

        {
          image: "bf-pack-instructions-secure-bars-v5",
          title: " Secure Your Bars",
          content: [
            "Rotate your fork 180 degrees, pointing your stem inward toward the frame",
            "Align your padded bars with the fork. Make sure that your brake and shifter levers are facing inward toward your frame",
            "Zip tie your padded bars to your fork.",
          ],
        },

        {
          image: "bf-pack-instructions-secure-seat-v5",
          title: " Secure Your Seatpost",
          content: [
            "Zip tie your padded seatpost to your padded frame - the top tube is usually a good place.",
          ],
        },

        {
          image: "bf-pack-instructions-secure-accessories-v5",
          title: " Secure Your Accessory Bag",
          content: [
            "Zip tie your accessory bag or box to the inside of your rear triangle",
            "Your accessory bag should contain your disc rotors, bottle cages, pedals and other small parts as well as your tools needed to reassemble your bike at your destination.",
          ],
        },

        {
          image: "BikeFlights_v4-wheel-bags",
          title: " Secure Your Wheels in Wheel Bags",
          content: [
            "Install and secure plastic end caps over your axles and cassette",
            "Place your wheels into padded wheel bags.",
          ],
        },

        {
          image: "bf-pack-instructions-ready-to-pack-v5",
          title: " Take Photos ",
          content: [
            "Document the contents of your shipment and its internal and external packing.",
            "In the unlikely event of loss or damage, such photos will help you remember what you packed and serve as proof of proper packing to submit with your claim.",
          ],
        },

        {
          image: "bf-pack-instructions-secure-in-box-v5",
          title:
            " Secure Your Bike and Wheels In a Sturdy Bike Box, Hard Case, or Soft Case",
          content: [
            "Place your bike and your wheels in your bike box, bike case, or bike bag.",
            "Utilize all of the accompanying straps, foam blocks, padded sleeves, bungees, and other protective elements included with your packing system",
            "Close your box or case, and secure it with packing tape or fasteners.",
          ],
        },

        {
          image: "BikeFlights_v4-shake-box",
          title: " Shake Your Box",
          content: [
            "Shake your bike box, hard case or soft case.",
            "Listen for rattling or clinging of loose items - if anything is loose, reopen your box, then pad and secure accordingly.",
          ],
        },

        {
          image: "bf-remove-shipping-label",
          title: "Remove or Cover All Old Labels and Barcodes",
          content: [
            "Accidental scans of old labels and other barcodes may result in your shipment being delayed, mis-routed or returned.",
          ],
        },

        {
          image: "bf-remove-hazard-labels",
          title: " REMOVE ALL HAZMAT AND WARNING STICKERS",
          content: [
            "Whether shipping a bicycle or an e-bike, our partner carriers require that you REMOVE ALL HAZMAT AND WARNING STICKERS from your box. Remaining stickers may result in a shipment delay and/or a fine.",
          ],
        },

        {
          image: "BikeFlights-labels-inside-box-edited-3",
          title: " Print and Place Label #1 In Your Box ",
          content: [
            "Print your label bundle, and place label #1 inside your bike box or case",
            "Use an inside label in the event that your outside label becomes unreadable or is accidentally removed.",
          ],
        },

        {
          image: "BikeFlights-zip-label",
          title: " Affix Label #2 To The Outside of Your Box Or Case",
          content: [
            "If using a hard or soft case, affix using a luggage tag. If you don’t have a luggage tag, you can get one at your local UPS, or make your own from scrap cardboard and packing tape.",
          ],
        },

        {
          image: "bf-pack-instructions-ship-your-bike",
          title: " Ship Your Bike",
          content: [
            "Drop off at one of our partner carrier locations, or kick back and wait for your pickup!",
          ],
        },
      ],
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
});
